import { useEffect, useState } from "react";

// Below this width (Tailwind `sm`) Antrian Kamar and Jadwal Pasien show one card per patient instead of the table, so
// nothing scrolls sideways on a phone.
const PHONE_QUERY = "(max-width: 639px)";

export default function usePhone() {
  const [phone, setPhone] = useState(() => typeof window !== "undefined" && Boolean(window.matchMedia?.(PHONE_QUERY).matches));
  useEffect(() => {
    const mq = window.matchMedia?.(PHONE_QUERY);
    if (!mq) return undefined;
    const update = () => setPhone(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);
  return phone;
}
